import {
  IMatchChangeHpTemplate,
  MatchChangeHp,
} from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { MatchChangeHpQuery, MatchChangeHpSubscription } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";
import { useSubscription } from "../../hooks/useSubscription";
import { graphql } from "appsync";
import subscriptionTrasformer from "./transformers/subscription";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<MatchChangeHpQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<MatchChangeHpQuery>): IMatchChangeHpTemplate => {
  return transformer(props);
};

const subscriptionDocument = graphql("subscription OnUpdateMatchChangeBySeasonIdAndCompId {\n  onUpdateMatchChangeById(id: \"unique\") {\n    id\n    matchList {\n      id\n      link\n      status\n      competitionPhase\n      competitionPhaseRound\n      competitionPhaseWinnerTeamId\n      customCompetitionName\n      date\n      hasVideoHighlights\n      away {\n        goal\n        id\n        logoUrl\n        negativeLogoUrl\n        name\n        overtimeGoal\n        shootoutGoal\n        totalGoalLegs\n      }\n      home {\n        goal\n        id\n        logoUrl\n        negativeLogoUrl\n        name\n        overtimeGoal\n        shootoutGoal\n        totalGoalLegs\n      }\n    }\n  }\n}")

const MatchChangeHpWidget = ({
  props,
  variables,
  ...rest
}: WidgetContext<IMatchChangeHpTemplate>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    IMatchChangeHpTemplate,
    MatchChangeHpSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: subscriptionTrasformer,
    mergeData: true,
  }) as IMatchChangeHpTemplate;

  return (
    <div onClick={intCmpEventHandler}>
      <MatchChangeHp {...updatedProps} />
    </div>
  );
};

export default MatchChangeHpWidget;
